<template>
  <div class="testimonials">
    <h2>What Our Partners Say</h2>
    <div class="testimonials-grid">
      <div
        v-for="(testimonial, index) in testimonials"
        :key="index"
        class="testimonial-card"
        data-aos="fade-up"
        data-aos-duration="1000"
        :data-aos-delay="index * 100"
        data-aos-once="true"
      >
        <div class="quote">
          {{ testimonial.quote }}
        </div>
        <div class="author">
          <div class="author-photo">
            <img :src="testimonial.photo" :alt="testimonial.name" />
          </div>
          <div class="author-info">
            <div class="author-name">{{ testimonial.name }}</div>
            <div class="author-title">{{ testimonial.title }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const { $Aos } = useNuxtApp();
const testimonials = ref([
  {
    quote:
      "Travvir has revolutionized how we conduct property showings. Our clients are consistently impressed with the quality of tours we can now provide.",
    name: "Michael Johnson",
    title: "Real Estate Photographer",
    photo:
      "https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-4.0.3&auto=format&fit=crop&w=256&h=256&q=80",
  },
  {
    quote:
      "The ability to create professional 360° tours directly from my smartphone has transformed my business. I can now offer premium virtual tour services at competitive rates.",
    name: "Emily Rodriguez",
    title: "Interior Design Studio",
    photo:
      "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&auto=format&fit=crop&w=256&h=256&q=80",
  },
  {
    quote:
      "Our hotel chain has seen a 40% increase in bookings since integrating Travvir's 360° tours onto our website. Customers love being able to virtually explore before booking.",
    name: "Robert Thompson",
    title: "Hospitality Group",
    photo:
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=256&h=256&q=80",
  },
]);

onMounted(() => {
  $Aos.init();
});
</script>

<style lang="scss" scoped>
.testimonials {
  padding: 6rem 2rem;

  @include respond-below(sm) {
    padding: 4rem 1rem;
  }

  h2 {
    font-style: normal;
    font-weight: 600;
    font-size: 39px;
    line-height: 1.5;
    color: rgba(255, 255, 255, 0.9);
    font-family: inherit;
    text-align: center;
    margin-bottom: 2rem;

    @include respond-below(sm) {
      font-size: 28px;
    }
  }

  .testimonials-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;
    max-width: 1200px;
    margin: 0 auto;

    @include respond-below(md) {
      grid-template-columns: 1fr;
    }

    .testimonial-card {
      background: rgba(255, 255, 255, 0.05);
      border-radius: 12px;
      padding: 2.5rem 2rem;
      transition: transform 0.3s ease;

      &:hover {
        transform: translateY(-5px);
      }

      .quote {
        font-size: 18px;
        line-height: 1.7;
        margin-bottom: 2rem;
        color: rgba(255, 255, 255, 0.4);
        font-style: italic;
        position: relative;

        &:before {
          content: '"';
          font-size: 60px;
          color: rgba(158, 8, 97, 0.3);
          position: absolute;
          top: -20px;
          left: -15px;
          z-index: -1;
        }
      }

      .author {
        display: flex;
        align-items: center;

        .author-photo {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          margin-right: 15px;
          overflow: hidden;
          border: 2px solid rgba(255, 255, 255, 0.2);

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }

        .author-info {
          display: flex;
          flex-direction: column;

          .author-name {
            font-weight: 600;
            font-size: 18px;
            margin-bottom: 0.3rem;
            color: rgba(255, 255, 255, 0.9);
          }

          .author-title {
            font-size: 14px;
            color: rgba(255, 255, 255, 0.4);
          }
        }
      }
    }
  }
}
</style>
